import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 xl-3" }
const _hoisted_2 = { class: "card-body border-top p-9" }
const _hoisted_3 = { class: "d-flex flex-stack" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "nav nav-tabs nav-line-tabs mb-5 fs-5" }
const _hoisted_6 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_7 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_10 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_11 = { class: "card mb-5 mb-xl-10" }
const _hoisted_12 = { class: "card mb-5 mb-xl-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditSchool = _resolveComponent("EditSchool")!
  const _component_ProgressSchool = _resolveComponent("ProgressSchool")!
  const _component_KonfigSchool = _resolveComponent("KonfigSchool")!
  const _component_DokumenPks = _resolveComponent("DokumenPks")!
  const _component_Penggunaanfitur = _resolveComponent("Penggunaanfitur")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              (_ctx.items.role != 'ADMIN_LEGAL' &&
            _ctx.items.role != 'ADMIN_CARD'
            )
                ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                    _createElementVNode("a", {
                      class: "nav-link active fs-5 text-dark text-hover-primary fw-bolder text-active-primary me-6",
                      "data-bs-toggle": "tab",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.infoSekolah())),
                      style: {"cursor":"pointer"}
                    }, "Form Informasi Sekolah")
                  ]))
                : _createCommentVNode("", true),
              (
            _ctx.items.role != 'ADMIN_CARD'
            )
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _createElementVNode("a", {
                      class: "nav-link fs-5 text-dark text-hover-primary fw-bolder text-active-primary me-6",
                      "data-bs-toggle": "tab",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.progress())),
                      style: {"cursor":"pointer"}
                    }, "Progres Sekolah")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_8, [
                _createElementVNode("a", {
                  class: "nav-link fs-5 text-dark text-hover-primary fw-bolder text-active-primary me-6",
                  "data-bs-toggle": "tab",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.konfigsekolah())),
                  style: {"cursor":"pointer"}
                }, "Konfigurasi Sekolah")
              ]),
              (_ctx.items.role != 'ADMIN_CARD')
                ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                    _createElementVNode("a", {
                      class: "nav-link fs-5 text-dark text-hover-primary fw-bolder text-active-primary me-6 hidden",
                      "data-bs-toggle": "tab",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.DokumenPks())),
                      style: {"cursor":"pointer"}
                    }, "Dokumen Sekolah")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.items.role != 'ADMIN_CARD' && _ctx.items.role !== 'ADMIN_LEGAL')
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _createElementVNode("a", {
                      class: "nav-link fs-5 text-dark text-hover-primary fw-bolder text-active-primary me-6 hidden",
                      "data-bs-toggle": "tab",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.Penggunaanfitur())),
                      style: {"cursor":"pointer"}
                    }, "Penggunaan Fitur")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.items.infoSekolah === true)
        ? (_openBlock(), _createBlock(_component_EditSchool, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.items.progress === true)
      ? (_openBlock(), _createBlock(_component_ProgressSchool, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.items.konfigsekolah === true)
        ? (_openBlock(), _createBlock(_component_KonfigSchool, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.items.DokumenPks === true)
        ? (_openBlock(), _createBlock(_component_DokumenPks, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.items.Penggunaanfitur === true)
        ? (_openBlock(), _createBlock(_component_Penggunaanfitur, { key: 2 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}